<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form ref="form" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="
                $l('table_label_fabric_search') ||
                '面料编号/面料名称/面料成分/颜色名称/颜色编号/需求人 搜索...'
              "
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- 头部按钮 -->
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad('genPurchase')"
              v-if="allow('A')"
            >
              {{ $l('btn_purchase') || '生成采购单' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_status') || '状态'">
              <el-checkbox-group v-model="form.resFabricDemandStatusList">
                <el-checkbox label="T">{{
                  $l('form_label_submitted') || '已提交'
                }}</el-checkbox>
                <el-checkbox label="P">{{
                  $l('form_label_purchased') || '已采购'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('form_label_received') || '已到货'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_fabric_no') || '面料编号'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.fabricNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_fabric_name') || '面料名称'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.fabricName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_fabric_content') || '面料成分'"
            >
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.fabricContent"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_color_name') || '颜色名称'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.colorName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_fty_color_no') || '颜色编号'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.ftyColorNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_demand_person_name') || '需求人姓名'"
            >
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.demandPersonName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="onReset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="query">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  fabricNo: '',
  fabricName: '',
  fabricContent: '',
  colorName: '',
  ftyColorNo: '',
  demandPersonName: '',
  resFabricDemandStatusList: ['T', 'Y', 'P'],
}
export default {
  data() {
    return {
      visible: false,
      form: { ...initForm },
    }
  },
  methods: {
    closeDialog() {
      this.visible = false
    },
    onReset() {
      this.form = { ...initForm }
    },
    fromLoad(val) {
      this.$emit(val)
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    reset() {
      this.onReset()
      this.query()
    },
  },
  created() {
    this.reset()
  },
}
</script>
